import { Component, Input, OnChanges } from '@angular/core';
import { getCFBHostForManageCustomFieldsLink, getNQSHostForManageNamedQueriesLink } from '@ddv/http';
import { IconComponent } from '@hs/ui-core-presentation';

@Component({
    selector: 'ddv-user-preferences-external-links',
    templateUrl: './external-links.component.html',
    styleUrls: ['./external-links.component.scss'],
    imports: [
        IconComponent,
    ],
})
export class ExternalLinksComponent implements OnChanges {
    @Input() clientCode: string | undefined;

    protected nqsRouterLink: string | undefined;
    protected cfbRouterLink: string | undefined;

    ngOnChanges(): void {
        const nqs = `https://${getNQSHostForManageNamedQueriesLink()}/#`;
        this.nqsRouterLink = `${nqs}/${this.clientCode}/queries/new`;

        const cfb = `https://${getCFBHostForManageCustomFieldsLink()}/#`;
        this.cfbRouterLink = `${cfb}/${this.clientCode}/fields/new`;
    }
}
